module.exports = __webpack_public_path__ + "static/2-09572811915131b4c044eaab2b1482cd.png";